import React from "react";

import Grid from "@material-ui/core/Grid";

import { SubtleBadge } from "components/Badge";
import { FormCollapse } from "components/Form";
import { SellViaExAgentRebates } from "components/Form/FormikControls/SellViaExAgentRebates";
import { Row } from "components/Layout";

import { FinanceSubModalSection } from "constants/settings";

import { useSectionHelper } from "hooks";

export const SellViaExAgentRebatesSection = ({ sectionHelper }) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.SELL_VIA_EX_AGENT_REBATES,
  );

  const header = (
    <Row>
      <SubtleBadge>Sell via External Agent Rebates</SubtleBadge>
    </Row>
  );

  return (
    <FormCollapse isOpen={isOpen} onToggle={onToggle} header={header}>
      <Grid item xs={12}>
        <SellViaExAgentRebates tooltip="The rebate your agency owes another agency when that agency sells stock on your behalf." />
      </Grid>
    </FormCollapse>
  );
};
